import { menuItems } from '../data/data';

export const RoutePath = {
  ABOUT: 'about',
  DEVELOPERS: 'developers',
  PARTNERS: 'partners',
  PRICING: 'pricing',
  FAQ: 'faq',
  DOCUMENTS: 'documents',
  CONTACTS: 'contacts',
  LOGIN: 'login',
  DESING: 'design',
} as const;

// console.log(menuItems);
menuItems.forEach((item) => {
  const key = item.path.toUpperCase() as keyof typeof RoutePath;
  if (key in RoutePath) {
    (RoutePath as Record<string, string>)[key] = item.path;
  }
});
